import { changeEmployeeDetail } from "api/services/employee";
import { Button } from "components/Button";
import FilterSelect from "components/Form/filterSelect";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDateHandler2 } from "utils/common";

export const EmploymentDetails = ({ userData, userSalaryData, fetchInfo }) => {
  const [employmentData, setEmploymentData] = useState([]);
  const [salaryInfoData, setSalaryInfoData] = useState([]);
  const [filtereSalaryData, setFiltereSalaryData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const EXCLUDED_PAY_CODES = useMemo(
    () => new Set(["SYSANNUAL", "SYSPENEME", "SYSPENEMP"]),
    []
  );
  
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);
  const {
    position,
    positionLoading
  } = useSelector((state) => state.common);
  const [editDesignation, setEditDesignation] = useState(false)

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const [salaryTotals, setSalaryTotals] = useState()
  const [salarySeries, setSalarySeries] = useState()
  const [salaryLabels, setSalaryLabel] = useState()

  const [positionOption, setPositionOption] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState("");


useEffect(()=>{
  
  let _position = position.map(item=> {
      return{
          label: item.name,
          value: item.id
      }
  })
  

  setPositionOption(_position)

},[position])



  useEffect(() => {
    const emp = [
      { id: 1, title: "Designation", text: userData?.employment?.position?.name },
      { id: 2, title: "Department", text: userData?.employment?.department?.name },
      { id: 4, title: "Joining Date", text: formatDateHandler2(userData?.employment?.employment_date) },
      { id: 5, title: "Confirmation Date", text: formatDateHandler2(userData?.employment?.confirmation_date) },
      { id: 6, title: "Position Start Date", text: formatDateHandler2(userData?.employment?.position_start_date) },
      { id: 7, title: "Leave Balance", text: userData?.employment?.leave_balance },
      { id: 8, title: "Leave Negative Days", text: userData?.employment?.leave_negative_days },
      { id: 9, title: "Number of Warnings", text: userData?.employment?.no_of_warnings },
      { id: 11, title: "Notice Period", text: userData?.employment?.notice_period },
      { id: 12, title: "Notice Period Start Date", text: formatDateHandler2(userData?.employment?.notice_period_start_date) },
      { id: 13, title: "Termination Date", text: formatDateHandler2(userData?.employment?.termination_date) },
      { id: 14, title: "Grade", text: userData?.employment?.grade?.grade_name },
      { id: 15, title: "Cost Center", text: userData?.cost_center?.code && userData?.cost_center?.name ? `${userData?.cost_center?.code} - ${userData?.cost_center?.name}` : null },
    ].filter(item => item.text || item.id === 1); // Keep Designation even if empty, filter others
    setEmploymentData(emp);

    // Update salary information
    setSalaryInfoData(userSalaryData);
    if(userSalaryData.amount) {

            
        // Filter salary data to ensure valid entries
          const filtereSalaryData = userSalaryData?.data?.filter(item => {
            const payCode = String(item?.Pay_Code || "").toUpperCase();
            return (
              item?.Pay_Amount > 0 &&
              item?.Pay_Name !== "Gratuity Accrual" &&
              !EXCLUDED_PAY_CODES.has(payCode)
            );
          });
          setFiltereSalaryData(filtereSalaryData);

          const salarySeries = filtereSalaryData?.map(item => item.Pay_Amount) || [];
          setSalarySeries(salarySeries);

          const salaryLabels = filtereSalaryData?.map(item => item.Pay_Name) || [];
          setSalaryLabel(salaryLabels)

            const gratuityData = userSalaryData?.data?.find(item => item.Pay_Name == "Gratuity Accrual")
            console.log(userSalaryData, "userSalaryData")
            const salTotals = [
            // { id:2, title: "Gratuity Accural", text: "AED " + (gratuityData.Pay_Amount).toFixed(2)}
            ]
            setSalaryTotals(salTotals)
    }
   
   
  }, [userData, userSalaryData, EXCLUDED_PAY_CODES]);

  const donutChart = {
    chart: {
      height: isMobile ? 350 : 450,
      type: "donut",
      toolbar: {
        show: false,
      },
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      floating: false,
      fontSize: isMobile ? "11px" : "12px",
      fontFamily: "'Inter', sans-serif",
      fontWeight: 500,
      formatter: function(seriesName, opts) {
        if (!opts || !opts.w || !opts.w.globals) {
          return seriesName;
        }
        try {
          const value = opts.w.globals.series[opts.seriesIndex];
          const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
          const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
          return `${seriesName}: ${percentage}%`;
        } catch (error) {
          return seriesName;
        }
      },
      labels: {
        colors: ["#374151"],
        useSeriesColors: false,
      },
      itemMargin: {
        horizontal: isMobile ? 6 : 20,
        vertical: isMobile ? 4 : 8,
      },
      markers: {
        width: isMobile ? 8 : 10,
        height: isMobile ? 8 : 10,
        radius: 4,
        offsetX: -4,
        offsetY: 0,
      },
      offsetY: isMobile ? 0 : 10,
      ...(isMobile ? {} : {
        customLegendItems: salaryLabels,
        onItemClick: {
          toggleDataSeries: true
        }
      }),
    },
    plotOptions: {
      pie: {
        donut: {
          size: isMobile ? "60%" : "70%",
          background: "transparent",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: isMobile ? "13px" : "15px",
              fontWeight: 600,
              color: "#1f2937",
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: isMobile ? "18px" : "22px",
              fontWeight: 700,
              color: "rgb(211, 0, 26)",
              offsetY: 8,
              formatter: function (val) {
                if (!val && val !== 0) return "AED 0.00";
                try {
                  return `AED ${parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                } catch (error) {
                  return "AED 0.00";
                }
              },
            },
            total: {
              show: true,
              showAlways: true,
              label: "Total Salary",
              fontSize: isMobile ? "11px" : "13px",
              fontWeight: 600,
              color: "#6b7280",
              offsetY: 30,
              formatter: function (w) {
                if (!w || !w.globals || !w.globals.seriesTotals) {
                  return "AED 0.00";
                }
                try {
                  const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  return `AED ${total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                } catch (error) {
                  return "AED 0.00";
                }
              },
            },
          },
        },
        expandOnClick: true,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        if (!opts || !opts.w || !opts.w.globals) {
          return `AED ${parseFloat(val || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
        }
        try {
          const value = opts.w.globals.series[opts.seriesIndex];
          return `AED ${parseFloat(value || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
        } catch (error) {
          return `AED ${parseFloat(val || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
        }
      },
      style: {
        fontSize: isMobile ? "10px" : "11px",
        fontWeight: 600,
        colors: ["#ffffff"],
        fontFamily: "'Inter', sans-serif",
      },
      dropShadow: {
        enabled: true,
        blur: 3,
        opacity: 0.5,
        color: "#000000"
      },
      offsetY: 0,
    },
    colors: [
      "rgb(211, 0, 26)",      // Primary red
      "#f59e0b",              // Amber
      "#fbbf24",              // Yellow
      "#10b981",              // Emerald
      "#3b82f6",              // Blue
      "#8b5cf6",              // Violet
      "#ec4899",              // Pink
      "#14b8a6",              // Teal
      "#f97316",              // Orange
      "#06b6d4",              // Cyan
      "#84cc16",              // Lime
      "#a855f7"               // Purple
    ],
    series: salarySeries,
    labels: salaryLabels,
    tooltip: {
      enabled: true,
      theme: "light",
      style: {
        fontSize: "13px",
        fontFamily: "'Inter', sans-serif",
      },
      y: {
        formatter: function (val, opts) {
          if (!opts || !opts.w || !opts.w.globals) {
            return `AED ${parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          }
          try {
            const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
            return `AED ${parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (${percentage}%)`;
          } catch (error) {
            return `AED ${parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          }
        },
      },
      marker: {
        show: true,
      },
    },
    stroke: {
      show: true,
      curve: 'smooth',
      lineCap: 'round',
      colors: ['#ffffff'],
      width: 2,
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.1,
        }
      },
      active: {
        filter: {
          type: 'darken',
          value: 0.15,
        },
        allowMultipleDataPointsSelection: false,
      }
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 350,
          },
          legend: {
            fontSize: "10px",
            itemMargin: {
              horizontal: 5,
              vertical: 3,
            },
            markers: {
              width: 7,
              height: 7,
            },
          },
          plotOptions: {
            pie: {
              donut: {
                size: "60%",
              },
            },
          },
        },
      },
    ],
  };

  const submitData = () => {
    changeEmployeeDetail( userData?.id, {position: selectedPosition}).then(response=> {
      setEditDesignation(false)

      fetchInfo()
    })
  }

  return (
    <div className="tab-pane fade" id="emp_projects" style={{ padding: isMobile ? "8px 0 160px 0" : "12px" }}>
      <div className="row g-2" style={isMobile ? { marginLeft: "0", marginRight: "0" } : {}}>
        <div className={isMobile ? "col-12" : "col-md-6 d-flex"}>
          <div className="card shadow-sm profile-box flex-fill" style={{ 
            borderRadius: "8px", 
            border: "1px solid #e5e7eb",
            background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)",
            marginLeft: isMobile ? "8px" : "0px",
            marginRight: isMobile ? "8px" : "0px",
            marginBottom: isMobile ? "12px" : "0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
          }}>
            <div className="card-body" style={{ padding: isMobile ? "12px" : "16px" }}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h3 className="card-title mb-0" style={{ 
                  fontSize: isMobile ? "15px" : "16px",
                  fontWeight: "600",
                  color: "#1f2937"
                }}>
                  Employment Information
                </h3>
                {(userData?.id !== user?.id && user?.role?.access_scope == "all") && (
                  <Link
                    to="#"
                    onClick={() => {
                      setSelectedPosition(userData?.employment?.position?.id)
                      setEditDesignation(true)
                    }}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#ffffff",
                      textDecoration: "none",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}
                  >
                    <i className="fa fa-pencil" style={{ fontSize: "12px" }} />
                  </Link>
                )}
              </div>
              <ul className="personal-info" style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {employmentData.map((item) => (
                  <ListItem 
                    key={item.id} 
                    title={item.title} 
                    text={item.text} 
                    userData={userData} 
                    user={user} 
                    editDesignation={editDesignation} 
                    positionOption={positionOption} 
                    positionLoading={positionLoading} 
                    selectedPosition={selectedPosition} 
                    setSelectedPosition={setSelectedPosition} 
                    submitData={submitData} 
                    setEditDesignation={setEditDesignation}
                    isMobile={isMobile}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={isMobile ? "col-12" : "col-md-6 d-flex"}>
          <div className="card shadow-sm profile-box flex-fill" style={{ 
            borderRadius: "8px", 
            border: "1px solid #e5e7eb",
            background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)",
            marginLeft: isMobile ? "8px" : "0px",
            marginRight: isMobile ? "8px" : "0px",
            marginBottom: isMobile ? "12px" : "0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
          }}>
            <div className="card-body" style={{ 
              padding: isMobile ? "12px" : "16px",
              maxHeight: isMobile ? "none" : "600px",
              overflowY: isMobile ? "visible" : "auto"
            }}>
              <h3 className="card-title mb-2" style={{ 
                fontSize: isMobile ? "15px" : "16px",
                fontWeight: "600",
                color: "#1f2937"
              }}>
                Salary Information
              </h3>
              <ul className="personal-info" style={{ listStyle: "none", padding: 0, margin: 0, marginBottom: "24px" }}>
                {userSalaryData && salaryTotals?.map((item) => (
                  <ListItem 
                    key={item.id} 
                    title={item.title} 
                    text={item.text}
                    isMobile={isMobile}
                  />
                ))}
              </ul>
              {userSalaryData && salarySeries && (
                <>
                  <style>{`
                    #donut-chart-wrapper .apexcharts-legend {
                      display: flex !important;
                      flex-wrap: wrap !important;
                      justify-content: center !important;
                      align-items: flex-start !important;
                    }
                    ${!isMobile ? `
                      #donut-chart-wrapper .apexcharts-legend .apexcharts-legend-series {
                        flex: 0 0 calc(50% - 20px) !important;
                        max-width: calc(50% - 20px) !important;
                        margin: 6px 10px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: flex-start !important;
                      }
                    ` : `
                      #donut-chart-wrapper .apexcharts-legend .apexcharts-legend-series {
                        flex: 0 0 100% !important;
                        max-width: 100% !important;
                        margin: 4px 0 !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                      }
                    `}
                  `}</style>
                  <div id="donut-chart-wrapper" className="d-flex justify-content-center align-items-center" style={{ marginTop: "24px" }}>
                    <ReactApexChart
                      options={donutChart}
                      series={salarySeries}
                      type="donut"
                      height={isMobile ? 350 : 450}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ListItem = ({ title, text, type, userData, user, editDesignation, positionOption, positionLoading, submitData, selectedPosition, setSelectedPosition, setEditDesignation, isMobile }) => {
  // Don't render if no text value
  if (!text && title !== "Designation") return null;
  
  return (
    <li style={{ 
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      padding: isMobile ? "8px 0" : "8px 0",
      borderBottom: "1px solid #f0f0f0",
      transition: "background-color 0.2s"
    }}
    onMouseEnter={(e) => {
      if (!isMobile) {
        e.currentTarget.style.backgroundColor = "#f9fafb";
      }
    }}
    onMouseLeave={(e) => {
      if (!isMobile) {
        e.currentTarget.style.backgroundColor = "transparent";
      }
    }}
    >
      {
        (title == "Designation" && userData?.id !== user?.id && editDesignation ) ?
        <>
         <div style={{ 
           fontSize: isMobile ? "12px" : "13px",
           fontWeight: "600",
           color: "#6b7280",
           marginBottom: isMobile ? "8px" : "0",
           minWidth: isMobile ? "auto" : "140px"
         }}>{title}</div>
         <div style={{ flex: 1, display: "flex", gap: "8px", alignItems: "center", flexWrap: isMobile ? "wrap" : "nowrap" }}>
            <div style={{ flex: 1, minWidth: "150px" }}>
              <FilterSelect 
                isClearable={true}  
                onChange={e=>{setSelectedPosition(e.value)}} 
                optionLabel={"label"} 
                optionValue={'value'}  
                options={positionOption} 
                isLoading={positionLoading} 
                value={positionOption.find(item=>item.value==selectedPosition)} 
                placeholder={"Change Designation"}
              />
            </div>
            <Button 
              onClick={submitData} 
              className="btn btn-sm" 
              label="Update" 
              style={{
                background: "rgb(211, 0, 26)",
                borderColor: "rgb(211, 0, 26)",
                color: "#ffffff"
              }}
            />
            <Button 
              onClick={()=> setEditDesignation(false)} 
              className="btn btn-sm" 
              label="Cancel"
              style={{
                background: "#6b7280",
                borderColor: "#6b7280",
                color: "#ffffff"
              }}
            />
          </div>
        </>
        :
        <>
         <div style={{ 
           fontSize: isMobile ? "12px" : "13px",
           fontWeight: "600",
           color: "#6b7280",
           marginBottom: isMobile ? "4px" : "0",
           minWidth: isMobile ? "auto" : "140px"
         }}>{title}</div>
         <div style={{ 
           fontSize: isMobile ? "13px" : "14px",
           color: "#1f2937",
           flex: 1,
           fontWeight: "500"
         }}>
           {(type=="mailto" || type=="tel") ? (
             <a 
               href={`${type}:${text}`} 
               style={{ 
                 color: "rgb(211, 0, 26)",
                 textDecoration: "none",
                 transition: "text-decoration 0.2s"
               }}
               onMouseEnter={(e) => e.currentTarget.style.textDecoration = "underline"}
               onMouseLeave={(e) => e.currentTarget.style.textDecoration = "none"}
             >
               {text}
             </a>
           ) : (
             <div>{text}</div>
           )}
         </div>
        </>
      }
    </li>
  );
};
